<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de kilometrajes</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :loading="isloading"
                    :disabled="isloading"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="openNew"
                >
                    <v-icon class="white--text"
                        >mdi-account-plus-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Nuevo kilometraje</span>
        </v-tooltip>
        <v-row>
            <v-col cols="12" md="4" v-if="rol != 4 && rol != 5">
                <v-autocomplete
                    v-model="filters.id_agente"
                    :items="agentes"
                    item-value="id"
                    item-text="nombre"
                    label="Agente"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3"
                ><date-select
                    label="Fecha de inicio"
                    v-model="filters.fecha_inicio"
                ></date-select
            ></v-col>
            <v-col cols="12" md="3"
                ><date-select
                    label="Fecha de fin"
                    v-model="filters.fecha_fin"
                ></date-select
            ></v-col>
            <v-col cols="12" md="2"
                ><v-checkbox label="Todos" v-model="filters.todos"></v-checkbox
            ></v-col>
        </v-row>
        <v-data-table
            dense
            :headers="headers"
            :items="kms"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
            <template v-slot:item.fecha_inicio="{ item }">
                <span>{{ item.fecha_inicio | format_date }}</span>
            </template>
            <template v-slot:item.fecha_fin="{ item }">
                <span>{{ item.fecha_fin | format_date }}</span>
            </template>
            <template v-slot:item.km_inicio="{ item }">
                <span>{{ item.km_inicio | format_numero }}</span>
            </template>
            <template v-slot:item.km_fin="{ item }">
                <span>{{ item.km_fin | format_numero }}</span>
            </template>
            <template v-slot:item.pagado="{ item }">
                <v-icon v-if="item.pagado">mdi-check</v-icon>
            </template>
            <template v-slot:item.total="{ item }">
                <span>{{ item.total | format_precio }}</span>
            </template>
            <template v-slot:item.total_km="{ item }">
                <span>{{
                    (item.km_fin - item.km_inicio) | format_numero
                }}</span>
            </template>
            <template v-slot:item.foto_inicio="{ item }">
                <a
                    v-if="item.foto_inicio != null"
                    target="_blank"
                    :href="`/api/imagen-km-inicio/${item.id}`"
                >
                    <v-icon right style="color: black"> mdi-image </v-icon>
                </a>
            </template>
            <template v-slot:item.foto_fin="{ item }">
                <a
                    v-if="item.foto_fin != null"
                    target="_blank"
                    :href="`/api/imagen-km-fin/${item.id}`"
                >
                    <v-icon right style="color: black"> mdi-image </v-icon>
                </a>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    @click="openEdit(item)"
                    small
                    class="mr-2"
                    color="#1d2735"
                    style="font-size: 25px"
                    title="EDITAR"
                    >mdi-pencil-outline</v-icon
                >

                <v-icon
                    @click="openModal(item)"
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="BORRAR"
                    >mdi-trash-can</v-icon
                >
                <v-icon
                    v-if="item.pagado != 1"
                    @click="openPagadoModal(item)"
                    small
                    class="mr-2"
                    color="#1d2735"
                    style="font-size: 25px"
                    title="PAGAR"
                    >mdi-cash-register</v-icon
                >
            </template>
        </v-data-table>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="pagado_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas marcarlo como pagado?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            pagado_dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn
                        color="success"
                        large
                        @click="
                            saveKmQuery({
                                id: selectedItem.id,
                                id_agente: selectedItem.id_agente,
                                fecha_inicio: selectedItem.fecha_inicio,
                                km_inicio: selectedItem.km_inicio,
                                fecha_fin: selectedItem.fecha_fin,
                                km_fin: selectedItem.km_fin,
                                pagado: 1,
                            });
                            pagado_dialog = false;
                        "
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_save" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Guardar kilometraje
                </v-card-title>
                <v-card-text style="text-align: center">
                    <form ref="form_km">
                        <h4 style="padding-top: 1rem">Inicio de la semana</h4>
                        <v-row>
                            <v-col cols="12" md="4"
                                ><date-select
                                    label="Fecha"
                                    name="fecha_inicio"
                                    v-model="km.fecha_inicio"
                                ></date-select
                            ></v-col>
                            <v-col cols="12" md="4"
                                ><v-text-field
                                    label="Km"
                                    name="km_inicio"
                                    v-model="km.km_inicio"
                                ></v-text-field
                            ></v-col>
                            <v-col cols="12" md="4"
                                ><v-file-input
                                    label="Foto"
                                    name="foto_inicio"
                                    v-model="km.fi"
                                ></v-file-input
                            ></v-col>
                        </v-row>
                        <h4>Fin de la semana</h4>
                        <v-row>
                            <v-col cols="12" md="4"
                                ><date-select
                                    label="Fecha"
                                    name="fecha_fin"
                                    v-model="km.fecha_fin"
                                ></date-select
                            ></v-col>
                            <v-col cols="12" md="4"
                                ><v-text-field
                                    label="Km"
                                    name="km_fin"
                                    v-model="km.km_fin"
                                ></v-text-field
                            ></v-col>
                            <v-col cols="12" md="4"
                                ><v-file-input
                                    label="Foto"
                                    name="foto_fin"
                                    v-model="km.ff"
                                ></v-file-input
                            ></v-col>
                        </v-row>
                    </form>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog_save = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="saveKm()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import { filter } from "lodash";

export default {
    data() {
        return {
            filters: {
                fecha_inicio: null,
                fecha_inicio: null,
                id_agente: null,
            },
            pagado_dialog: false,
            agentes: [],
            search: "",
            headers: [],
            kms: [],
            km: {},
            selectedItem: 0,
            dialog: false,
            dialog_save: false,
            id_agente: null,
        };
    },
    created() {
        this.checkUser();
        this.getKms();
        this.getAgentes();
    },
    watch: {
        filters: {
            deep: true,
            handler(val) {
                this.getKms();
            },
        },
    },
    methods: {
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.agentes = res.data.Agentes;
                },
                (err) => {
                    this.$custom_error("Error consultando los agentes");
                }
            );
        },
        openNew() {
            this.km = {};
            this.dialog_save = true;
        },
        openEdit(item) {
            this.km = item;
            if (this.km.fecha_inicio == "0000-00-00") {
                this.km.fecha_inicio = null;
            }
            if (this.km.fecha_fin == "0000-00-00") {
                this.km.fecha_fin = null;
            }
            this.dialog_save = true;
        },
        saveKm() {
            let formdata = new FormData(this.$refs.form_km);
            formdata.append("id_agente", this.filters.id_agente);
            formdata.set("fecha_inicio", this.km.fecha_inicio);
            formdata.set("fecha_fin", this.km.fecha_fin);
            if (this.km.id != null) {
                formdata.set("id", this.km.id);
            }
            this.saveKmQuery(formdata);
        },
        saveKmQuery(data) {
            axios.post("api/save-agente-km", data).then((res) => {
                this.getKms();
                this.dialog_save = false;
            });
        },
        getKms() {
            let params = "";
            if (this.filters.fecha_inicio) {
                params += `&fecha_inicio=${this.filters.fecha_inicio}`;
            }
            if (this.filters.fecha_fin) {
                params += `&fecha_fin=${this.filters.fecha_fin}`;
            }
            if (this.filters.todos) {
                params += `&todos=${this.filters.todos}`;
            }
            axios
                .get(
                    `api/get-agente-kms?id_agente=${this.filters.id_agente}${params}`
                )
                .then(
                    (res) => {
                        this.kms = res.data;
                    },
                    (err) => {
                        this.$custom_error("Error consultando el kilometraje del agente");
                    }
                );
        },
        openModal(item) {
            this.selectedItem = this.kms.indexOf(item);
            this.dialog = true;
        },
        openPagadoModal(item) {
            this.selectedItem = item;
            this.pagado_dialog = true;
        },
        deleteUser() {
            axios
                .get(`api/delete-agente-km/${this.kms[this.selectedItem].id}`)
                .then(
                    (res) => {
                        this.$toast.sucs("Kilometraje eliminado con éxito");
                        this.dialog = false;
                        this.getKms();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el kilometraje");
                    }
                );
        },
        checkUser() {
            let email = localStorage.getItem("user_email");

            if (email == "asun@cerramientoscandela.com") {
                this.headers = [
                    {
                        text: "Fecha inicio",
                        value: "fecha_inicio",
                        sortable: false,
                    },
                    { text: "Km", value: "km_inicio", sortable: false },
                    { text: "Foto", value: "foto_inicio", sortable: false },
                    {
                        text: "Foto subida",
                        value: "fecha_foto_inicio",
                        sortable: false,
                    },
                    {
                        text: "Fecha fin",
                        value: "fecha_fin",
                        sortable: false,
                    },
                    { text: "Km", value: "km_fin", sortable: false },
                    { text: "Foto", value: "foto_fin", sortable: false },
                    {
                        text: "Foto subida",
                        value: "fecha_foto_fin",
                        sortable: false,
                    },
                    { text: "Total Km", value: "total_km", sortable: false },
                    { text: "Pagado", value: "pagado", sortable: false },
                    { text: "Importe", value: "total", sortable: false },
                    { text: "Acciones", value: "action", sortable: false },
                ];
            } else {
                this.headers = [
                    {
                        text: "Fecha inicio",
                        value: "fecha_inicio",
                        sortable: false,
                    },
                    { text: "Km", value: "km_inicio", sortable: false },
                    { text: "Foto", value: "foto_inicio", sortable: false },
                    {
                        text: "Fecha fin",
                        value: "fecha_fin",
                        sortable: false,
                    },
                    { text: "Km", value: "km_fin", sortable: false },
                    { text: "Foto", value: "foto_fin", sortable: false },
                    { text: "Total Km", value: "total_km", sortable: false },
                    { text: "Pagado", value: "pagado", sortable: false },
                    { text: "Importe", value: "total", sortable: false },
                    { text: "Acciones", value: "action", sortable: false },
                ];
            }
        },
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
        rol: function () {
            return localStorage.getItem("role");
        },
    },
};
</script>
